// Stripe Configuration for Website
// Uses environment variable or defaults to test key in development

const isDevelopment = process.env.NODE_ENV === 'development';

export const STRIPE_CONFIG = {
	// Development: Use TEST publishable key (pk_test_...)
	// Production: Use LIVE publishable key (pk_live_...)
	PUBLISHABLE_KEY: isDevelopment
		? "pk_test_51SIabzAj8hbXeB6SIk4pRbeGN5UmIuW6g8U00sFCTbwAa1eTSE6MJH0cW2LPUqIaySLRfaUjN4SGpVSScpAUakP600GhX60oIc" // TEST key
		: "pk_live_51SIabkPPR1fC6U6vUd9xlvqW3GQIzQzv4XO22d18cOKJPoXYeGNVajTgDRXKq6Eh34GtQv7IY9PUiE1hdiisbWBB00KNpbwIjb", // LIVE key
	ENVIRONMENT: isDevelopment ? "test" : "live",
};

// Subscription plans configuration
export const SUBSCRIPTION_PLANS = [
	{
		idAbonnementType: 1,
		libelle: "Starter",
		prixMensuel: 9.99,
		prixAnnuel: 99.99,
		color: "#4CAF50",
		features: [
			"Entraînements illimités",
			"Synchronisation cloud",
			"Templates personnalisés",
			"Dashboard mobile",
			"Jusqu'à 10 élèves",
			"Planification avancée"
		]
	},
	{
		idAbonnementType: 2,
		libelle: "Pro",
		prixMensuel: 19.99,
		prixAnnuel: 199.99,
		color: "#2196F3",
		features: [
			"Entraînements illimités",
			"Synchronisation cloud",
			"Templates personnalisés",
			"Dashboard mobile",
			"Planification avancée",
			"Dashboard Coach web",
			"Jusqu'à 100 élèves"
		]
	}
];
